import { api } from './api.js';
import { auth } from './auth.js';
import { navigate } from './router.js';

/**
 * Sign the user out everywhere: revoke the refresh token server-side (best
 * effort — if the call fails, the local session is still cleared so the user
 * isn't trapped in a half-signed-in state), wipe local storage, and route back
 * to onboarding.
 */
export async function logout({ redirectTo = '/onboarding' } = {}) {
  const refresh = auth.getRefreshToken();
  if (refresh) {
    try {
      await api('/auth/logout', { method: 'POST', body: { refresh_token: refresh } });
    } catch { /* ignore — we still want to clear local state */ }
  }
  auth.clear();
  navigate(redirectTo);
}
